/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type EventPendingView_pendingEvent$ref: FragmentReference;
declare export opaque type EventPendingView_pendingEvent$fragmentType: EventPendingView_pendingEvent$ref;
export type EventPendingView_pendingEvent = {|
  +id: string,
  +sgId: ?number,
  +name: ?string,
  +$refType: EventPendingView_pendingEvent$ref,
|};
export type EventPendingView_pendingEvent$data = EventPendingView_pendingEvent;
export type EventPendingView_pendingEvent$key = {
  +$data?: EventPendingView_pendingEvent$data,
  +$fragmentRefs: EventPendingView_pendingEvent$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "EventPendingView_pendingEvent",
  "type": "Event",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "sgId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "name",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '9c28a900c65b496e53fbdef051f8bbb8';

module.exports = node;
